import React, { forwardRef, memo } from "react";
import PropTypes from "prop-types"; // For prop validation
import { styled } from "@mui/material/styles";
import { motion, AnimatePresence } from "framer-motion";
import CarouselItem from "./CarouselItem";
import { Box } from "@mui/material";
import LoadingBox from "../../_default/LoadingBox";

// Define the styled CarouselInner component
const CarouselInner = styled(motion.div)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  flexWrap: "nowrap",
  alignItems: "stretch",
  width: "100%",
  height: "100%",
  overflow: "hidden",
  paddingTop: "5px",
  paddingBottom: "5px",
}));

// Define slide variants based on direction
const slideVariants = {
  enter: (direction) => ({
    x: direction === 1 ? "100%" : "-100%", // Slide in from right (1) or left (-1)
    opacity: 0,
  }),
  center: {
    x: 0,
    opacity: 1,
  },
  exit: (direction) => ({
    x: direction === 1 ? "-100%" : "100%", // Slide out to left (-1) or right (1)
    opacity: 0,
  }),
};

const CarouselSlides = forwardRef(
  (
    { currentBlock = [], direction = 1, itemwidthpx, CardComponent = null },
    ref
  ) => {
    return (
      <Box
        component="div"
        ref={ref} // Attach the forwarded ref
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          boxSizing: "border-box",
          height: "100%",
          width: "100%",
        }}
      >
        {currentBlock.length === 0 ? (
          <LoadingBox isLoading={true}  isFullScreen={false} text="Loading..." styleLoadingBox={{}} />
        ) : (
          <AnimatePresence
            initial={true}
            custom={direction}
            style={{ width: "100%", height: "100%" }}
          >
            <CarouselInner
              custom={direction}
              variants={slideVariants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{
                duration: 0.5,
                ease: [0.4, 0, 0.2, 1],
              }}
            >
              {currentBlock.map((item, index) => (
                <CarouselItem
                  key={item.id}
                  index={index}
                  length={currentBlock.length - 1}
                  item={item}
                  itemwidthpx={itemwidthpx}
                  CardComponent={CardComponent || DefaultCard}
                />
              ))}
            </CarouselInner>
          </AnimatePresence>
        )}
      </Box>
    );
  }
);

// Default CardComponent if none is provided
const DefaultCard = () => <div>Default Card</div>;


export default memo(CarouselSlides);
